var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 16.82 0.82 C 16.815 2.645 17.758 4.341 19.31 5.3 C 20.196 5.868 21.227 6.17 22.28 6.17 L 22.28 10 C 20.326 10.006 18.418 9.405 16.82 8.28 L 16.82 16.1 C 16.82 20 13.58 23.17 9.61 23.17 C 8.132 23.174 6.688 22.728 5.47 21.89 C 3.549 20.583 2.397 18.413 2.39 16.09 C 2.442 11.76 6.295 8.467 10.58 9.09 L 10.58 13.01 C 8.475 12.326 6.314 13.887 6.3 16.1 C 6.3 17.35 7.02 18.43 8.07 18.97 C 8.52 19.2 9.04 19.34 9.6 19.34 C 11.353 19.353 12.804 17.981 12.89 16.23 L 12.89 0.82 L 16.81 0.82 L 16.82 0.82 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLine);
export default __webpack_public_path__ + "static/media/tiktok_line.67722053767722865cf3b37ec846b2b6.svg";
export { ForwardRef as ReactComponent };